module.exports = __webpack_public_path__ + "img/cg_dried_star.fab989d2.jpg";